<input
  type="text"
  [value]="time"
  [required]="isRequired"
  placeholder="HH:MM"
(input)="onTimeChange($event)"
/>
